import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from './Dropdown';
import { NativeDropdown } from './NativeDropdown';

const DynamicDropdown = ({ children, useNative, ...other }) => {
  const Component = useNative ? NativeDropdown : Dropdown;

  return (
    <Component {...other}>
      {children}
    </Component>
  );
};

DynamicDropdown.displayName = 'DynamicDropdown';

DynamicDropdown.propTypes = {
  /**
   * A list of `MenuItem` elements to populate the dropdown with.
   */
  children: PropTypes.node.isRequired,
  /**
   * If true, will use `NativeDropdown` otherwise `Dropdown` will be used.
   */
  useNative: PropTypes.bool,
};

DynamicDropdown.defaultProps = {
  useNative: false
};

export { DynamicDropdown };
